import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { WallCaption } from './WallCaption';
import type { AnnaStage } from './useAnnaStage';
interface CaptionAreaProps {
  stage: AnnaStage;
  nothingGoingOn: boolean;
  compact?: boolean;
}
const EASE = [0.23, 1, 0.32, 1] as const;
const fade = {
  initial: {
    opacity: 0
  },
  animate: {
    opacity: 1
  },
  exit: {
    opacity: 0
  },
  transition: {
    duration: 0.3
  }
};
function ambientLine(waiting: number) {
  if (waiting === 0) return 'Rustig in huis. Niets wacht op je.';
  if (waiting === 1) return 'Rustig in huis. 1 ding wacht op je, niets dringends.';
  return `Rustig in huis. ${waiting} dingen wachten op je, niets dringends.`;
}

/** Directly under Anna: her live caption, the quiet-mode line, or the one-line ambient summary. */
export function CaptionArea({
  stage,
  nothingGoingOn,
  compact = false
}: CaptionAreaProps) {
  return <AnimatePresence mode="wait" data-id="element-1433" data-mp="jt9rvzjsutpw">
      {stage.caption ? <motion.div key={stage.caption.id} initial={{
      opacity: 1
    }} exit={{
      opacity: 0,
      transition: {
        duration: 0.3,
        ease: EASE
      }
    }} data-id="element-1434" data-mp="jvvy9vuyf36j">
          <WallCaption text={stage.caption.text} revealed={stage.revealed} compact={compact} data-id="element-1435" data-mp="3mch7floftpef" />
        </motion.div> : stage.quietLine && stage.view === 'stage' ? <motion.p key="quiet" {...fade} className="text-[26px] text-amber" data-id="element-1436" data-mp="37hufg4bvfutu">
          {stage.quietLine}
        </motion.p> : nothingGoingOn ? <motion.p key="ambient" {...fade} className="font-display text-[28px] font-light text-ink-soft lg:text-[32px]" data-id="element-1437" data-mp="2ym4xy6djnklq">
          {ambientLine(stage.pending.length)}
        </motion.p> : null}
    </AnimatePresence>;
}